import { createFileRoute, Outlet } from '@tanstack/react-router'
import useEmblaCarousel from 'embla-carousel-react'

export const Route = createFileRoute('/auth')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="relative flex flex-1">
      <div
        className="absolute inset-0 -z-10 bg-[#D91F2EBF]/70"
        style={{
          backgroundImage: 'url(/img/auth/bg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 -z-10 bg-[#D91F2EBF]/70" />
      <div className="container mx-auto grid gap-4 px-4 py-8 md:grid-cols-2 md:py-16">
        <div className="hidden md:block">
          <AuthCarousel />
        </div>
        <div className="shrink">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

function AuthCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    // Autoplay({ playOnInit: true, delay: 3000 }),
  ])
  // const { scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)

  return (
    <div className="w-full">
      <div
        className="mx-auto flex"
        style={
          {
            '--slide-spacing': '1rem',
            '--slide-size': '70%',
          } as React.CSSProperties
        }
      >
        <div ref={emblaRef} className="w-full overflow-hidden">
          <div
            style={{
              backfaceVisibility: 'hidden',
              display: 'flex',
              touchAction: 'pan-y pinch-zoom',
              marginLeft: 'calc(var(--slide-spacing) * -1)',
            }}
          >
            {CAROUSELS.map(({ title, description, image }, index) => (
              <div
                key={index}
                className="flex h-full w-full flex-col items-center justify-center gap-2"
                style={{
                  paddingLeft: 'var(--slide-spacing)',
                  minWidth: 0,
                  flex: '0 0 100%',
                }}
              >
                <div
                  className="w-full"
                  style={{
                    maxWidth: '352.07px',
                    maxHeight: '322.42px',
                  }}
                >
                  <img
                    src={image}
                    alt={title}
                    width={352.07}
                    height={322.42}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <p className="font-tomorrow mt-8 text-center text-3xl font-semibold text-white">
                  {title}
                </p>
                <p className="text-center text-lg text-white">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="mt-12 flex items-center justify-center gap-2">
        {/* {scrollSnaps.map((_, index) => (
          <button
            key={index}
            className={cn(
              'rounded-full border-2 border-secondary p-1 transition-colors duration-300',
              {
                'bg-secondary': index === emblaApi?.selectedScrollSnap(),
              },
            )}
            onClick={() => onDotButtonClick(index)}
            aria-label="Scroll to slide"
          >
            <span className="sr-only">Slide {index + 1}</span>
          </button>
        ))} */}
      </div>
    </div>
  )
}

const CAROUSELS = [
  {
    title: 'Diajarkan oleh praktisi yang berpengalaman di bidangnya',
    description: '',
    image: '/img/auth/carousel-1.png',
  },
  {
    title: 'Belajar Lebih Asik dengan Materi Bite-Size Interaktif',
    description:
      'Belajar jadi lebih cepat dan mudah dengan ratusan ilustrasi dan soal-soal',
    image: '/img/auth/carousel-2.png',
  },
  {
    title: 'Miliki Sertifikat untuk tiap skill',
    description:
      'Miliki sertifikat keahlian yang menjadi nilai tambah di CVmu!',
    image: '/img/auth/carousel-3.png',
  },
]
